import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.values.js";
export var allowedTooltipSymbols = {
  Button: Symbol('Button'),
  ButtonLink: Symbol('ButtonLink'),
  Chip: Symbol('Chip'),
  CountryButton: Symbol('CountryButton'),
  FileListItem: Symbol('FileListItem'),
  InnerChip: Symbol('InnerChip'),
  Link: Symbol('Link'),
  Tag: Symbol('Tag'),
  TooltipIcon: Symbol('Tooltip.Icon')
};
export function checkIsTooltipAllowed(child) {
  return child instanceof Object && 'type' in child && !!Object.getOwnPropertySymbols(child.type).find(function (symbol) {
    return Object.values(allowedTooltipSymbols).includes(symbol);
  }) && (Object.getOwnPropertySymbols(child.type).includes(allowedTooltipSymbols.Tag) ? child.props.as === 'button' : true);
}